import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { Buffer } from 'buffer';
import { Provider } from 'react-redux'
import store from './store';
import axios from 'axios';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      let errorMessage = error.response?.data?.message || error.response?.data?.error?.message || '';
      if (Array.isArray(errorMessage)) errorMessage = errorMessage[0];

      const isRoleChange = typeof errorMessage === 'string' && (errorMessage.includes('User role has changed') || errorMessage.includes('Security update'));
      const existingLogoutMessage = sessionStorage.getItem('logoutMessage');
      
      localStorage.clear();
      
      if (isRoleChange) {
        sessionStorage.setItem('logoutMessage', errorMessage);
      } else if (existingLogoutMessage) {
        sessionStorage.setItem('logoutMessage', existingLogoutMessage);
      }
      
      const path = window.location.pathname;
      const isPublicRoute = path.startsWith('/login') || 
                            path.startsWith('/forgotpassword') || 
                            path.startsWith('/resetpassword') || 
                            path.startsWith('/setpassword');
                            
      if (!isPublicRoute) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);
if (typeof window !== 'undefined' && !window.Buffer) {
  window.Buffer = Buffer;
}

// Suppress findDOMNode deprecation warning from react-transition-group (used by react-bootstrap-table-next)
// This is a known issue and doesn't affect functionality - the library works fine with React 18
const originalError = console.error;
const originalWarn = console.warn;

console.error = function(...args) {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('findDOMNode is deprecated and will be removed in the next major release')
  ) {
    return;
  }
  return originalError.call(console, ...args);
};

console.warn = function(...args) {
  if (
    typeof args[0] === 'string' &&
    (args[0].includes('UNSAFE_componentWillReceiveProps') ||
     args[0].includes('Using UNSAFE_componentWillReceiveProps in strict mode') ||
     args[0].includes('Support for defaultProps will be removed from function components'))
  ) {
    return;
  }
  return originalWarn.call(console, ...args);
};

const root = createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
